<template>
    <div class="w-100 d-none p-0" :id="'choice-'+id">
        <div role="button" tabindex="0" @keydown.enter.prevent="$event.currentTarget.click()" @keydown.space.prevent="$event.currentTarget.click()" :class="'mb-2 d-flex align-items-center guesswapp-choice p-3 rounded-3 position-relative' +  is_selected() + is_correct() ">
            <span class="choice-letter me-3">{{ utils.get_choice_character(id) }}</span>
            <span class="choice-text">{{ choice }}</span>
            <img v-if="is_correct() == ' correct '" class="true-response position-absolute end-0" width="55" src="@/assets/true.svg">
        </div>
    </div>
</template>

<script>
    import utils from '@/../../shared/utils';

    export default {
        name: 'ChoiceV1',
        data(){
            return {
                utils: utils,
            };
        },
        computed: {
            handle_class (){
                let item_class = "";

                if(this.is_correct(this.id))
                    item_class += " result-correct ";

                if(this.is_selected(this.id))
                    item_class += " selected ";


                return item_class;
            }
        },
        props:{
            id: {
                type: Number,
                default: null,
                required: true
            },
            selected: {
                type: Boolean,
                default: false,
                required: false,
            },
            correct: {
                type: Boolean,
                default: false,
                required: false,
            },
            choice: {
                type: String,
                default: null,
                required: true
            }
        },
        mounted()
        {
            setTimeout(function(){
                $('#choice-'+this.id).removeClass("d-none").addClass("animate__animated animate__bounceInUp");
            }.bind(this), this.id * 300);
        },
        methods:{
            is_selected(){
                let activity = this.user_activity();
                if(activity)
                {
                    if(activity.choice.includes(this.id))
                        return " selected ";
                }
                return "";
            },
            is_correct(){
                if(this.$store.state.game.state == this.utils.GAME_STATES.RESULT)
                {
                    if((this.$store.state.game.question.question.correctAnswer || []).includes(this.id))
                        return " correct ";
                    else
                        return " wrong ";
                }

                return "";
            },
            user_activity(){
                let user_data = this.$store.state.game.clients.find((cli) => {
                    return cli.username == this.$store.state.game.user.username;
                });
                if(user_data)
                {
                    if(user_data.data)
                    {
                        let activity = user_data.data.find((q) => {
                            return q.question == this.$store.state.game.current_question
                        })
                        return activity;
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .guesswapp-choice
    {
        border: 2px solid var(--vc-line-strong);
        background-color: var(--vc-paper-50);
        color: var(--vc-text-900);
        font-size: 1.1rem;
        font-weight: 600;
    }

    .choice-letter
    {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        flex-shrink: 0;
        border-radius: 8px;
        background: var(--vc-ink-900);
        color: var(--vc-paper-50);
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 0.9rem;
    }

    .selected
    {
        border-color: var(--vc-accent-500);
        background-color: var(--vc-accent-100);
    }
    .selected .choice-letter
    {
        background: var(--vc-accent-600);
    }

    .selected.correct, .correct
    {
        border-color: var(--vc-success-500) !important;
        background-color: var(--vc-success-100) !important;
    }
    .selected.correct .choice-letter, .correct .choice-letter
    {
        background: var(--vc-success-500);
    }

    .selected.wrong
    {
        border-color: var(--vc-danger-500) !important;
        background-color: var(--vc-danger-100) !important;
    }
    .selected.wrong .choice-letter
    {
        background: var(--vc-danger-500);
    }

</style>